
/**
 * Utility to play notification sounds throughout the application
 */
export const playNotificationSound = async () => {
  try {
    const audio = new Audio('/notification-sound.mp3');
    await audio.play();
  } catch (error) {
    console.warn('Could not play notification sound:', error);
    // Fallback to alternate sound location
    try {
      const backupAudio = new Audio('/assets/sounds/notification.mp3');
      await backupAudio.play();
    } catch (fallbackError) {
      console.error('Could not play fallback notification sound:', fallbackError);
    }
  }
};

/**
 * Play a sound for backup operations
 */
export const playBackupSound = async () => {
  try {
    // Use the notification sound also for backups
    await playNotificationSound();
  } catch (error) {
    console.warn('Could not play backup notification sound:', error);
  }
};
